import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

export const getAllCurrencyService = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'system/get-all-currency', {}, {
    server: microServices.SERVICE_URL_1,
    handlerEnabled: true
  })
}

export const getGameDetailsService = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'system/get-game-settings', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table
  })
}

/** Fetches list of games (id, name, status) from backend - used for lobby game type mapping */
export const getGamesListService = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'system/get-game-details', {}, {
    server: microServices.SERVICE_URL_1,
    handlerEnabled: false
  })
}

export const verifyRoundHashService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'poker-game/check-fairness', data, {
    server: microServices.SERVICE_URL_1
  })
}
